import { Route } from "react-router-dom";
import oopsImage from "src/assets/oops.svg";
import { useHistory } from "react-router-dom";
import { useSelector } from "react-redux";
import { matchPath } from "react-router";

const PrivateRoute = ({ component: Component, module, key, componentProps = {}, ...rest }) => {

  let doctorVerified = useSelector((state) => state.user.user.doctorVerified);
  if (doctorVerified === undefined || doctorVerified === null) {
    const stored = sessionStorage.getItem("doctorVerified");
    if (stored !== null) {
      doctorVerified = stored === "true" || stored === true;
    }
  }

  const history = useHistory();

  // Check if current path is open-patient-app
  const isOpenPatientApp = matchPath(window.location.pathname, {
    path: "/open-patient-app/:clinicId",
    exact: true,
    strict: false,
  });

  // Allow access to doctor module if:
  // 1. Doctor is verified OR
  // 2. Doctor is not verified but accessing profile/fee pages OR
  // 3. It's the open-patient-app route (which should bypass verification)
  if (module === "doctor" && (
    doctorVerified === true ||
    (doctorVerified === false && ["/profile", "/fee", "/subscription"].includes(rest.path)) ||
    isOpenPatientApp
  )) {
    return (
      <Route
        {...rest}
        exact
        key={key}
        render={(props) => { return <Component {...props} {...componentProps} />; }}
      />
    );
  } else
    return (
      <>
        <Route
          {...rest}
          exact
          key={key}
          render={() => (
            <div className="d-flex justify-content-center align-items-center flex-column w-100 docg-vh-standard">
              <img style={{ maxWidth: 600 }} src={oopsImage} alt="verification issue" />
              <br />
              <p className="get-txt">
                Please, Complete
                <span style={{ color: "#c06c84", cursor: "pointer" }} onClick={() => history.push("/profile")}> Profile </span>
                and
                <span style={{ color: "#c06c84", cursor: "pointer" }} onClick={() => history.push("/fee")}> Fee </span>
                Page.
              </p>
              <span>Now,
                <button onClick={() => history.push("/")}>
                  <i><u>Click here to Login again</u></i>
                </button>
              </span>
            </div>
          )}
        />
      </>
    )
};

export default PrivateRoute;